<app-tooltip [message]="tooltip" [dynamic]="false" class="display-inline-flex">
  <button (click)="click()" [attr.class]="class" [attr.data-cy]="dataCy" [attr.disabled]="disabled ? true : null"
    [attr.id]="id">
    <span [attr.class]="icon"></span>
    <span class="text">{{text}}</span>
  </button>
  @if (loading) {
    <app-loading-spinner class="button-spinner"></app-loading-spinner>
  }
</app-tooltip>
